import { createSlice } from "@reduxjs/toolkit";
import {cancelPaymentAction, createPaymentAction, fetchPaymentStatus, fetchPriceApparat, refreshPriceApparat} from '../actions/paymentsActions'

const initialState = {
    payments: [],
    priceApparat: null,
    loadingPayment: false,
    error: null,
    // Тело последнего запроса на создание платежа. Нужно, чтобы экран оплаты
    // мог перевыпустить QR, когда картинка не пришла: отдельного эндпоинта
    // «дай QR по этому платежу» на бэкенде нет, единственный способ —
    // повторить POST /api/v1/payments/create с тем же payload.
    lastPaymentRequest: null,
    // Результат опроса GET /payments/status (PaymentPage.jsx, раз в 3с, пока
    // не пришёл терминальный статус). null — опрос ещё не начался/не ответил
    // ни разу; не путать с paymentStatus.status === "pending".
    paymentStatus: null,
    // Параметры экрана EditManyDocs на момент перехода к оплате:
    // { idsKey, docSettings, selectedDocId }. Они живут в локальном state
    // компонента и терялись бы при возврате после «Отменить» на экране оплаты.
    orderDraft: null,
    // true — заказ отменён кнопкой, EditManyDocs при монтировании должен
    // поднять orderDraft (и сбросить флаг). Без флага черновик не
    // подставляется: «Распечатать ещё» после печати начинает с чистого листа.
    restoreOrderDraft: false,
    };

const paymentsReducer = createSlice({
    name: "payments",
    initialState,
    reducers: {
        // The QR/payment request timed out or the user cancelled it
        // (usePaymentRequest.js). createPaymentAction itself keeps running in
        // the background — this only unblocks the UI; the caller ignores the
        // eventual late result.
        paymentRequestCancelled(state) {
            state.loadingPayment = false;
        },
        orderDraftSaved(state, action) {
            state.orderDraft = action.payload;
            state.restoreOrderDraft = false;
        },
        orderDraftRestored(state) {
            state.restoreOrderDraft = false;
        },
    },
        extraReducers: builder => {
            builder
                .addCase(refreshPriceApparat.fulfilled, (state, action) => {
                    state.priceApparat = action.payload;
                })
                .addCase(createPaymentAction.pending, (state, action) => {
                    state.loadingPayment = true
                    state.error = null
                    state.lastPaymentRequest = action.meta.arg
                })
                .addCase(createPaymentAction.fulfilled, (state, action) => {
                    state.loadingPayment = false
                    state.payments = action.payload
                    // Новый заказ (в т.ч. переизданный тот же order_id при
                    // антиспам-переиспользовании на бэкенде) — статус
                    // предыдущего опроса больше не про этот платёж.
                    state.paymentStatus = null
                })
                .addCase(createPaymentAction.rejected, (state, action) => {
                    state.loadingPayment = false
                    state.error = action.payload
                })
                .addCase(fetchPaymentStatus.fulfilled, (state, action) => {
                    state.paymentStatus = action.payload
                })
                .addCase(cancelPaymentAction.fulfilled, (state, action) => {
                    state.paymentStatus = action.payload
                    state.restoreOrderDraft = true
                })
                // .rejected намеренно не обрабатываем: одиночный сетевой сбой
                // опроса не должен затирать последний известный статус и
                // перекрашивать экран — следующий тик (3с) попробует снова.
                .addCase(fetchPriceApparat.pending, state => {
                    state.loadingPayment = true
                    state.error = null
                })
                .addCase(fetchPriceApparat.fulfilled, (state, action) => {
                    state.loadingPayment = false
                    state.priceApparat = action.payload 
                })
                .addCase(fetchPriceApparat.rejected, (state, action) => {
                    state.loadingPayment = false
                    state.error = action.payload
                })
        },
});


export const {
    fetchPaymentsStart,
    fetchPaymentsSuccess,
    fetchPaymentsFailure,
    createPaymentStart,
    createPaymentSuccess,
    createPaymentFailure,
    fetchPriceApparatStart,
    fetchPriceApparatSuccess,
    fetchPriceApparatFailure,
    paymentRequestCancelled,
    orderDraftSaved,
    orderDraftRestored,
} = paymentsReducer.actions;
export default paymentsReducer.reducer;
